export default "__VITE_ASSET__CSWHacfa__"